
enum VideoSourceEnum {
    Undefined = 0,
    Azure = 1,
    Youtube = 2,
    Vimeo = 3
}
export default VideoSourceEnum
